module.exports = __webpack_public_path__ + "img/linkedin.c1bc34b7.svg";